import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HistoryLogEvaluationActions } from './history-log-evaluation.actions';
import { HistoryLogEvaluationService } from '../../service/history-log-evaluation.service';
import { PageInput } from '../../../../graphql/generated';

@Injectable()
export class HistoryLogEvaluationEffects {
    loadRiskMapHistoryLog$ = createEffect(
        (rs: HistoryLogEvaluationService = inject(HistoryLogEvaluationService)) => {
            return this.actions$.pipe(

                ofType(HistoryLogEvaluationActions.loadEvaluationHistoryLog),
                mergeMap(({ parameters, legalEntityId, campaignId }) =>
                    rs.fetchRiskMapHistoryLog(parameters, legalEntityId, campaignId).pipe(
                        map((historyLog) => {
                            return HistoryLogEvaluationActions.loadEvaluationHistoryLogSuccess({
                                historyLog
                            });
                        }),
                        catchError((error) => of(HistoryLogEvaluationActions.loadEvaluationHistoryLogFailure({ error })))
                    )
                )
            );
        },
        { functional: true }
    );

    constructor(private actions$: Actions) { }
}
